import $ from "jquery";

$(function () {
  if (typeof belizeFlights !== "undefined") {
    var allLines = [];

    for (var key in belizeFlights) {
      if (belizeFlights.hasOwnProperty(key)) {
        window["line" + key] = new LeaderLine(
          document.getElementById(key),
          document.getElementById("belize"),
          {
            dash: { animation: true },
            path: "fluid",
            hide: true,
            startLabel: key.toUpperCase(),
            middleLabel: LeaderLine.captionLabel(belizeFlights[key].duration, {
              color: "black",
            }),
          }
        );
        allLines.push("line" + key);
      }
    }

    $(".location-pin").on("click", function () {
      hideAllLines();
      $(".c-flight-map").addClass("location-search");
      $(".c-flight-map").removeClass("airline-search");
      $("#airlines").val("AIRLINES");
      $(".c-flight-map__arrows").hide();
      $(".c-flight-map__flight-box").removeClass("active");
      var id = $(this).attr("id");
      window["line" + id].show("draw");
      $(".c-flight-map__flight-box[data-airport='" + id + "']").each(function (
        i
      ) {
        if (i === 0) {
          $(".c-flight-map__flight-box").removeClass("active");
          $(this).addClass("active");
          $(".c-flight-map__arrows").hide();
        } else {
          $(".c-flight-map__arrows").show();
        }
      });
      var airline = $(
        ".c-flight-map__flight-box[data-airport='" + id + "']"
      ).attr("data-airline");
    });

    $(window).resize(function () {
      hideAllLines();
    });

    function hideAllLines() {
      allLines.forEach((element) => window[element].hide());
    }

    $("#airlines").on("change", function (e) {
      hideAllLines();
      $(".c-flight-map").removeClass("location-search");
      $(".c-flight-map").addClass("airline-search");
      var airline = this.value;
      $(".c-flight-map__flight-box").hide();
      $(".c-flight-map__flight-box[data-airline='" + airline + "']").each(
        function (i) {
          if (i === 0) {
            $(".c-flight-map__flight-box").removeClass("active");
            $(this).addClass("active");
            var airport = $(this).attr("data-airport");
            window["line" + airport].show("draw");
            $(this).show();
            $(".c-flight-map__arrows").hide();
          } else {
            $(".c-flight-map__arrows").show();
          }
        }
      );
    });

    $(".c-flight-map__arrows button").on("click", function () {
      var current = $(".c-flight-map__flight-box.active");
      var airport = current.attr("data-airport");
      var airline = current.attr("data-airline");
      var next;
      if ($(".c-flight-map").hasClass("location-search")) {
        // if ($(this).hasClass("slick-next")) {
        next = current.nextAll("[data-airport='" + airport + "']:first");
        if (!next.length) {
          next = $("[data-airport='" + airport + "']").first();
        }
        // } else {
        //   next = current.prevAll("[data-airport='" + airport + "']:first");
        //   if (!next.length) {
        //     next = $("[data-airport='" + airport + "']").last();
        //   }
        // }
        if (next.length) {
          next.addClass("active");
          current.removeClass("active");
          hideAllLines();
          airport = next.attr("data-airport");
          window["line" + airport].show("draw");
        }
      } else {
        // if ($(this).hasClass("slick-next")) {
        next = current.nextAll("[data-airline='" + airline + "']:first");
        if (!next.length) {
          next = $("[data-airline='" + airline + "']").first();
        }
        // } else {
        // next = current.prevAll("[data-airline='" + airline + "']:first");
        // if (!next.length) {
        //   next = $("[data-airline='" + airline + "']").last();
        // }
        // }
        if (next.length) {
          next.addClass("active");
          current.removeClass("active");
          hideAllLines();
          airport = next.attr("data-airport");
          window["line" + airport].show("draw");
        }
      }
    });

    // $("#svgMap").on("click", function (e) {
    // var map = document.getElementById("svgMap");
    // var width = map.offsetWidth;
    // var height = map.offsetHeight;
    // console.log(width);
    // var rect = e.currentTarget.getBoundingClientRect();
    // var x = e.clientX - rect.left; //x position within the element.
    // var y = e.clientY - rect.top; //y position within the element.
    // var xPercent = x / width;
    // var yPercent = y / height;
    // alert(xPercent + ", " + yPercent);
    // });
  }
});
